import React from "react";
import T from "prop-types";
import Icon from "../Icon/Icon";

export default function EditButton({ handleClick }) {
  return (
    <button
      type="button"
      className="btn btn-primary btn-hollow pull-right"
      onClick={handleClick}
    >
      <Icon name="pencil" />
      <span className="edit-button-padding">Edit</span>
    </button>
  );
}

EditButton.propTypes = {
  handleClick: T.func.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/Edit/EditButton.jsx